/**
 * @generated SignedSource<<6157e5bd8a643496c070324e9da372ae>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DepartmentAvailabilitySidebar_session$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ScheduleSwitcher_session">;
  readonly " $fragmentType": "DepartmentAvailabilitySidebar_session";
};
export type DepartmentAvailabilitySidebar_session$key = {
  readonly " $data"?: DepartmentAvailabilitySidebar_session$data;
  readonly " $fragmentSpreads": FragmentRefs<"DepartmentAvailabilitySidebar_session">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DepartmentAvailabilitySidebar_session",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ScheduleSwitcher_session"
    }
  ],
  "type": "Session",
  "abstractKey": null
};

(node as any).hash = "9356f056ee7f22449fe37e65b482816f";

export default node;
